import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DesignComponent } from './components/design/design.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { OutdatedTestComponent } from './components/outdated-test/outdated-test.component';
import { MessagesComponent } from './components/messages/messages.component';
import { DemosComponent } from './components/demos/demos.component';
import { ErrorComponent } from './components/error/error.component';
import { DialogsComponent } from './components/dialogs/dialogs.component';
import { GamtestStartComponent } from './components/gamtest-start/gamtest-start.component';
import { authGuard } from './guards/auth.guard';
import { testGuard } from './guards/test.guard';
import { messagesEnabledGuard } from './guards/messages-enabled.guard';
import { NotLoggedInComponent } from './components/not-logged-in/not-logged-in.component';

const routes: Routes = [
  { path: '', redirectTo: 'not-logged-in', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'dashboard/:jwt', component: DashboardComponent },
  { path: 'dialogs/:dialog', component: DialogsComponent, canActivate: [authGuard] },
  { path: 'dialogs/:dialog/:jwt', component: DialogsComponent },
  { path: 'messages', component: MessagesComponent, canActivate: [messagesEnabledGuard, authGuard] },
  { path: 'messages/:jwt', component: MessagesComponent, canActivate: [messagesEnabledGuard] },
  { path: 'gamtest-start', component: GamtestStartComponent },
  { path: 'gamtest-start/:jwt', component: GamtestStartComponent },

  { path: 'welcome', component: WelcomeComponent },
  { path: 'outdated-test', component: OutdatedTestComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'not-logged-in', component: NotLoggedInComponent },

  { path: 'design', component: DesignComponent, canActivate: [testGuard] },
  { path: 'demos', component: DemosComponent, canActivate: [testGuard] },
  { path: '**', component: PageNotFoundComponent }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
